import React from 'react';

type TrackingData = Record<string, any>;

const TrackingContext = React.createContext<TrackingData>({});

export function useTracking() {
  return React.useContext(TrackingContext);
}

export function TrackingProvider({
  value,
  children
}: React.PropsWithChildren<{ value: TrackingData }>) {
  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
}
